<template>
  <card>
    <template #header>
      <card-header>
        {{ $t("homes.overdueReminder") }}
        <template #action>
          <el-link type="primary" :underline="false" @click="more">
            {{ $t("global.more") }}
            <i class="el-icon-arrow-right" style="color:#999999;" />
          </el-link>
        </template>
      </card-header>
    </template>
    <div class="overdue-list">
      <el-table
        class="overdue-table"
        :data="tableData"
        :show-header="false"
        style="width: 100%"
        :cell-style="cellStyle"
        @row-click = "rowClick"
        :row-style="rowStyle"
      >
        <el-table-column prop="companyName" label="公司名称" show-overflow-tooltip align="center" />
        <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip align="center" />
        <el-table-column prop="stageName" label="阶段名称" show-overflow-tooltip align="center" />
        <el-table-column prop="estimatedEndDate" label="阶段结束日期" show-overflow-tooltip align="center" />
        <el-table-column label="逾期天数" align="center">
          <template slot-scope="scope">
            <span class="dueDays">{{ scope.row.dueDay }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </card>
</template>

<script>
import { overDue } from '@/api/homes'

export default {
  name: '',
  components: {},
  mixins: [],
  props: {
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.autoLoad) this.loadData(null)
  },
  mounted() {},
  destroyed() {},
  methods: {
    cellStyle() {
      return {
        borderBottom: 'none'
      }
    },
    loadData(companyId) {
      // alert(companyId)
      overDue(1, 3, companyId).then(resp => {
        this.tableData = resp.data.list
      })
    },
    more() {
      //this.$router.push({ path: '/projectManagement/projectListView', query: { overdue: '1',isAvaliable:0 }})
      this.$emit('more')
    },
    // toProjectExec(projectId) {
    //   this.$router.push({ path: '/projectManagement/projectProcessExcute', query: { id: projectId }})
    // },
    rowClick(row){
      this.$router.push({ path: '/projectManagement/projectProcessExcute', query: { id: row.projectId,phaseId:row.phaseId }})
    },
    rowStyle(){
      return {cursor:'pointer'}
    }
  }
}
</script>
<style lang="scss" scoped>
.overdue-list {
  height: 130px;

  .overdue-table::before {
    height: 0;
  }
}

.dueDays{
  color:#FE0000;
  cursor:pointer;
  font-size:18px;
  font-weight:bold;
}

</style>
